import commonButton from './commonButton.ui';

export default commonButton;
